export const filterOptions = (options, input) => {
    /**
     * Return all options when input is empty
     */
    if (!input)
        return options;
    return options.filter(option => {
        const label = option.label.toLowerCase();
        const value = option.value.toLowerCase();
        /**
         * Return all options matching `label` or `value`
         */
        return (value.indexOf(input.toLowerCase()) > -1 ||
            label.indexOf(input.toLowerCase()) > -1);
    });
};
export const containsNode = (parent, child) => {
    return child && parent && parent.contains(child);
};
/**
 * Convert an array of strings to select options
 */
export const formInputSelectValueToOption = (options, value) => {
    if (!value)
        return [];
    const values = Array.isArray(value) ? value : [value];
    const updates = options.filter(option => values.includes(option.value) && option);
    return updates;
};
/**
 * Convert options to array of strings or string
 */
export const formInputSelectOptionToValue = (options, multi = false) => {
    if (options.length === 0)
        return multi ? [] : '';
    if (multi)
        return options.map(option => option.value);
    return options[0].value;
};
